import classNames from "classnames";
import React from "react";
import { LinkInfo } from "../models/shared/LinkInfo";
import { SanityImageSourceExt } from "../models/shared/SanityImageSourceExt";
import { ImagePresetCollection } from "../utilities/image";
import LinkWithArrow from "./LinkWithArrow";
import { Picture } from "./Picture";

export interface CardsGridProps {
  title?: string;
  cards?: {
    button: LinkInfo;
    image: {
      alt: string;
      asset: SanityImageSourceExt;
    };
    title: string;
  }[];
}

const imagePresets: ImagePresetCollection = {
  default: {
    height: 360
  },
  lg: {
    width: 600
  }
};

export const CardsGrid = ({ title = "", cards = [] }: CardsGridProps) => {
  const numColumns = Math.min(cards.length, 4);

  const gridClasses = {
    1: "grid-cols-1",
    2: "grid-cols-1 sm:grid-cols-2",
    3: "grid-cols-1 sm:grid-cols-2 lg:grid-cols-3",
    4: "grid-cols-1 sm:grid-cols-2 lg:grid-cols-4"
  };

  return (
    <aside className="max-w-screen-xl mx-auto mb-12 px-4 md:px-6 lg:mb-32">
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <h2 className="text-4xl leading-9 sm:text-4xl sm:leading-10">{title}</h2>
        </div>
        <div className={classNames("mt-12 grid gap-5 mx-auto", gridClasses[numColumns])}>
          {cards?.map(card => (
            <div
              key={card.title}
              className="flex flex-col overflow-hidden rounded-2xl border border-brand-primary-95 shadow-lg shadow-[#e5e5e5]"
            >
              <div className="flex-shrink-0 border-b-3 border-[silver]">
                <Picture
                  image={card.image}
                  presets={imagePresets}
                  imgClassName="h-48 max-h-[15rem] w-full object-cover"
                />
              </div>
              <div className="flex-1 bg-white p-6 flex flex-col justify-between">
                <div className="flex flex-col flex-1 justify-between">
                  <h3 className="mt-2 text-xl leading-7 font-semibold text-brand-primary-20">
                    {card.title}
                  </h3>
                  <div className="flex">
                    <LinkWithArrow
                      linkInfo={card.button}
                      colorClasses="text-brand-primary-70 border-brand-primary-70 text-base"
                    />
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </aside>
  );
};

